export default __webpack_public_path__ + "static/media/work.da3ebee3.svg";